import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import foto01 from "../assets/04.png";
import foto02 from "../assets/10.jpg";
import foto03 from "../assets/11.jpg";
import foto04 from "../assets/12.jpg";
import foto05 from "../assets/13.jpg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "../style/studioGallery.css";


const StudioGallery = () => {
  var settings = {
    dots: true,
    infinite: true, 
    autoplaySpeed: 3000,
    autoplay: true,    
    centerMode: true,
    fade: true    
  }

  return (
    <>
    
    <div className="studioGalleryBG">
    <Container className="slider">
      <Row>
        <div>
          <h2 className="my-4 py-4 sectionTitle">Gallery</h2>
        </div>
      </Row>      
      <Slider  {...settings}>        
          {/* <img className="sliderImg" src={foto01}/> */}      
          <img className="sliderImg" src={foto01}/>    
          <img className="sliderImg" src={foto02}/>      
          <img className="sliderImg" src={foto03}/>        
          <img className="sliderImg" src={foto04}/>  
          <img className="sliderImg" src={foto05}/>        
          {/* <img className="sliderImg" src={foto05}/> */} 
      </Slider>
    </Container> 
    </div>
    </>
  );
};

export default StudioGallery;
